import { motion } from 'framer-motion';
import styled from 'styled-components';

export const ActivityCard = styled(motion.img)`
  object-fit: cover;
  width: 100%;
  max-width: 342px;
`;
